// src/reducers/scheduleReducer.js

import {
  GET_SCHEDULE_DATA_REQUEST,
  GET_SCHEDULE_DATA_SUCCESS,
  GET_SCHEDULE_DATA_FAILURE,
  SAVE_TEMPLATE_SLOT_SUCCESS,
  ADD_DAY_OFF_SUCCESS,
  ADD_BLOCKER_SUCCESS,
  DELETE_SCHEDULE_ENTRY_SUCCESS,
} from '../actions/types';

const initialState = {
templateSlots: [],
daysOff: [],
blockers: [],
isLoading: false,
error: null,
};

export const scheduleReducer = (state = initialState, action) => {
switch (action.type) {
  case GET_SCHEDULE_DATA_REQUEST:
    return { ...state, isLoading: true, error: null };

  case GET_SCHEDULE_DATA_SUCCESS:
    // This logic handles the OLD API format (a single flat array).
    // It sorts the data here on the frontend.
    const allData = Array.isArray(action.payload) ? action.payload : [];

    const blockers = allData.filter(item => 
        item.date && item.date.trim() !== '' && item.slot && item.slot.trim() !== '' && item.slot.trim() !== 'DAY_OFF'
    );

    const daysOff = allData.filter(item => 
        item.date && item.date.trim() !== '' && (!item.slot || item.slot.trim() === '' || item.slot.trim() === 'DAY_OFF')
    );

    const templateSlots = allData.filter(item => 
        (!item.date || item.date.trim() === '') && item.day
    );
    
    return { 
        ...state, 
        isLoading: false,
        templateSlots,
        daysOff,
        blockers,
    };

    case GET_SCHEDULE_DATA_FAILURE:
      return { 
        ...state, 
        isLoading: false, 
        error: action.payload,
        templateSlots: [],
        daysOff: [],
        blockers: [],
      };
  case SAVE_TEMPLATE_SLOT_SUCCESS:
    return { ...state, templateSlots: [...state.templateSlots, action.payload] };
  
  case ADD_DAY_OFF_SUCCESS:
    return { ...state, daysOff: [...state.daysOff, action.payload] };

  case ADD_BLOCKER_SUCCESS:
    return { ...state, blockers: [...state.blockers, action.payload] };

  case DELETE_SCHEDULE_ENTRY_SUCCESS:
    const { id } = action.payload;
    return {
      ...state,
      templateSlots: state.templateSlots.filter(slot => slot.id !== id),
      daysOff: state.daysOff.filter(day => day.id !== id),
      blockers: state.blockers.filter(blocker => blocker.id !== id),
    };

  default:
    return state;
}
};